@if (loading$ | async) {
<div class="spinner-container" aria-hidden="true" inert>
    <br-loading [visible]="true" size="medium"></br-loading>
</div>
}